export default "__VITE_ASSET__970PZKQn__ 376w";